import { useMemo } from 'react'

import IconButton from '@components/IconButton/IconButton'
import { faClose } from '@fortawesome/pro-light-svg-icons'
import { Stack, useTheme } from '@mui/material'
import { Toaster as RHTToaster, toast, ToastBar } from 'react-hot-toast'

import getToastOptions from './toastOptions'

export default function Toaster() {
	const theme = useTheme()
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const toastOptions = useMemo(() => getToastOptions(theme), [])

	return (
		<RHTToaster reverseOrder={false} position="top-right" toastOptions={toastOptions}>
			{(t) => (
				<ToastBar toast={t}>
					{({ message }) => (
						<>
							{message}
							{t.type !== 'loading' && (
								<Stack direction="row" spacing={1}>
									<IconButton
										size="small"
										sx={{ color: 'inherit' }}
										onClick={() => toast.dismiss(t.id)}
										icon={faClose}
									/>
								</Stack>
							)}
						</>
					)}
				</ToastBar>
			)}
		</RHTToaster>
	)
}
